import swal from "sweetalert2";
import createSpinner from "../../../Shared/Functions/createSpinner";

export default /*@ngInject*/ function ($uibModalInstance, riskLevelsData, helperService, riskLevel, existingOrdinals) {

    const vm = this;

    if (riskLevel === 'New') {
        vm.riskLevel = {};
        vm.maxInput = Math.max(...existingOrdinals) + 1;
        vm.riskLevel.Ordinal = vm.maxInput;     
    } else {
        vm.riskLevel = { ...riskLevel };
        vm.originalOrdinal = vm.riskLevel?.Ordinal ? vm.riskLevel.Ordinal : null;
        vm.maxInput = Math.max(...existingOrdinals);
    }

    vm.cancel = cancel;
    vm.submitForm = submitForm;

    async function createRiskLevel() {
        vm.loading = new createSpinner();
        let postData = { Name: vm.riskLevel.Name, Ordinal: vm.riskLevel.Ordinal };

        try {
            let response = await riskLevelsData.createRiskLevel(postData);
            let riskLevelId = response.data;
            await helperService.successfulSaveButton(vm.loading);
            $uibModalInstance.close(riskLevelId);
        } catch {
            vm.loading.loadingValue = false;
        }
    }

    async function renameRiskLevel() {
        vm.loading = new createSpinner();

        let putData = {
            Name: vm.riskLevel.Name,
            Id: vm.riskLevel.Id,
            Ordinal: vm.riskLevel.Ordinal
        };

        try {
            await riskLevelsData.renameRiskLevel(putData);
            await helperService.successfulSaveButton(vm.loading);
            $uibModalInstance.close();
        } catch {
            vm.loading.loadingValue = false;
        }
    }

    async function submitForm() {
        let max = Math.max(...existingOrdinals);
        let exists = existingOrdinals.find(eo => eo === vm.riskLevel.Ordinal);

        if (vm.riskLevel.Id) {
            if (vm.riskLevel.Ordinal < max || exists !== vm.originalOrdinal) {
                await checkOrdinalSequence();
            }
            renameRiskLevel();
        } else {
            if (vm.riskLevel.Ordinal < max || exists) {
                await checkOrdinalSequence();
            }
            createRiskLevel();
        }
    }

    async function checkOrdinalSequence() {
        await swal(helperService.areYouSureParams('Risk Levels ReSequencing', 'The ordinal detected will cause the existing Risk Levels to resequence. Are you sure you want to continue?', 'Yes'));
    }

    function cancel() {
        $uibModalInstance.dismiss();
    }
}